/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
import TransferDom from "vux/src/directives/transfer-dom/index.js";
export default {
  name: 'SmyPopup',
  props: {
    value: Boolean,
    popupStyle: {
      type: Object
    },
    transfer: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      show: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      this.$emit('input', val);
    }
  }
};